<template>
  <div @click="toggleDropdown(false)">
    <VirtualList
      class="leaderboard h-screen flex flex-col overflow-y-scroll bg-gray-700 bg-cover"
      :class="[sortMode, { loading }]"
      wrap-class="rows w-full flex-1 max-w-screen-lg m-auto bg-gradient-to-br from-gray-400 to-gray-600"
      item-class="row bg-gray-300"
      header-class="sticky top-0 z-10"
      :estimate-size="36"
      :keeps="50"
      :data-sources="filteredPlayers"
      :data-component="LeaderboardPlayer"
      data-key="id"
      :style="{ backgroundImage }"
    >
      <LeaderboardHeader slot="header" />
      <LeaderboardFooter slot="footer" />
    </VirtualList>
    <LeaderboardCountries />
  </div>
</template>

<script>
  import VirtualList from 'vue-virtual-scroll-list'
  import { mapState, mapGetters, mapActions } from 'vuex'
  import LeaderboardHeader from './LeaderboardHeader.vue'
  import LeaderboardFooter from './LeaderboardFooter.vue'
  import LeaderboardPlayer from './LeaderboardPlayer.vue'
  import LeaderboardCountries from './LeaderboardCountries.vue'

  export default {
    components: {
      VirtualList,
      LeaderboardHeader,
      LeaderboardFooter,
      LeaderboardCountries,
    },
    data() {
      return {
        LeaderboardPlayer,
      }
    },
    computed: {
      ...mapState(['loading']),
      ...mapGetters(['filteredPlayers', 'sortMode']),
      backgroundImage() {
        const index = Math.round(Math.random() * 3) + 1
        return `url('bg/artwork${index}.jpg')`
      },
    },
    methods: {
      ...mapActions(['fetchDates', 'updateData', 'toggleDropdown']),
    },
    created() {
      this.fetchDates().then(this.updateData)
    },
  }
</script>
